import React from 'react';
import { ButtonLink } from '@goodfynd/react-web.lib.ui';
import type { ButtonLinkProps } from '@goodfynd/react-web.ui.button';
import { Text } from '@goodfynd/react-web.ui.text';

import { StyledActionContainer, StyledContainer, StyledImage } from './styles';

export default function CmsDashboardCta({
  ctas,
  description,
  image,
  title,
  ...props
}: CmsDashboardCtaProps) {
  return (
    <StyledContainer {...props}>
      {!!image && (
        <StyledImage alt={title ?? ''} height={120} src={image} width={120} />
      )}

      {!!title && (
        <Text align="center" as="heading5">
          {title}
        </Text>
      )}

      {!!description && (
        <Text align="center" as="body1" style={{ marginTop: 8 }}>
          {description}
        </Text>
      )}

      {ctas?.[0] && (
        <StyledActionContainer>
          {ctas.map(
            ({
              button_href = '',
              button_text,
              button_type,
              open_in_new_window,
            }) => (
              <ButtonLink
                href={button_href}
                key={button_text}
                target={open_in_new_window ? '_blank' : undefined}
                type={button_type as ButtonLinkProps['type']}
              >
                {button_text}
              </ButtonLink>
            )
          )}
        </StyledActionContainer>
      )}
    </StyledContainer>
  );
}
